

// THIS FILE IS FOR EDITING THE PROJECTS, TESTIMONIALS, AND SKILLS SECTIONS OF THE PORTFOLIO SITE SUCH AS PICTURES //


export const projects = [
 
  {
    title: "Parece Que Va Llover",
    subtitle: "Weather App",
    description:
      "The user is able to search for there city and weather information will be displayed. Technologies used: JavaScript, HTML, CSS, Bootstrap, Api's. Visit: https://openweathermap.org/ for an API key.The user is able to search for there city and weather information will be displayed. Technologies used: JavaScript, HTML, CSS, Bootstrap, Api's. Visit: https://openweathermap.org/ for an API key.",
    image: "./evcharger.jpg",
  },
  
  {
    title: "Password Generator",
    subtitle: "Password App",
    description:
      "The user is able to search for there city and weather information will be displayed. Technologies used: JavaScript, HTML, CSS, Bootstrap, Api's. Visit: https://openweathermap.org/ for an API key.The user is able to search for there city and weather information will be displayed. Technologies used: JavaScript, HTML, CSS, Bootstrap, Api's. Visit: https://openweathermap.org/ for an API key.",
    image: "./evcharger3.jpg",
  },

{
    title: "Error 404",
    subtitle: "Responsive 404",
    description:
      "The user is able to search for there city and weather information will be displayed. Technologies used: JavaScript, HTML, CSS, Bootstrap, Api's. Visit: https://openweathermap.org/ for an API key.The user is able to search for there city and weather information will be displayed. Technologies used: JavaScript, HTML, CSS, Bootstrap, Api's. Visit: https://openweathermap.org/ for an API key.",
    image: "./IMG_1672.jpg",
  },

{
    title: "Error 404",
    subtitle: "Responsive 404",
    description:
      "The user is able to search for there city and weather information will be displayed. Technologies used: JavaScript, HTML, CSS, Bootstrap, Api's. Visit: https://openweathermap.org/ for an API key.The user is able to search for there city and weather information will be displayed. Technologies used: JavaScript, HTML, CSS, Bootstrap, Api's. Visit: https://openweathermap.org/ for an API key.",
    image: "./IMG_2034.PNG",
  },





  {
    title: "Error 404",
    subtitle: "Responsive 404",
    description:
      "The user is able to search for there city and weather information will be displayed. Technologies used: JavaScript, HTML, CSS, Bootstrap, Api's. Visit: https://openweathermap.org/ for an API key.The user is able to search for there city and weather information will be displayed. Technologies used: JavaScript, HTML, CSS, Bootstrap, Api's. Visit: https://openweathermap.org/ for an API key.",
    image: "./IMG_2103.jpg",
  },
  {
    title: "Error 404",
    subtitle: "Responsive 404",
    description:
      "The user is able to search for there city and weather information will be displayed. Technologies used: JavaScript, HTML, CSS, Bootstrap, Api's. Visit: https://openweathermap.org/ for an API key.The user is able to search for there city and weather information will be displayed. Technologies used: JavaScript, HTML, CSS, Bootstrap, Api's. Visit: https://openweathermap.org/ for an API key.",
    image: "./homelight0.jpg",
  },
  {
    title: "Error 404",
    subtitle: "Responsive 404",
    description:
      "The user is able to search for there city and weather information will be displayed. Technologies used: JavaScript, HTML, CSS, Bootstrap, Api's. Visit: https://openweathermap.org/ for an API key.The user is able to search for there city and weather information will be displayed. Technologies used: JavaScript, HTML, CSS, Bootstrap, Api's. Visit: https://openweathermap.org/ for an API key.",
    image: "./homelight01.jpg",
  },
  {
    title: "Error 404",
    subtitle: "Responsive 404",
    description:
      "The user is able to search for there city and weather information will be displayed. Technologies used: JavaScript, HTML, CSS, Bootstrap, Api's. Visit: https://openweathermap.org/ for an API key.The user is able to search for there city and weather information will be displayed. Technologies used: JavaScript, HTML, CSS, Bootstrap, Api's. Visit: https://openweathermap.org/ for an API key.",
    image: "./kitchenremodel.jpg",
  },
  {
    title: "Error 404",
    subtitle: "Responsive 404",
    description:
      "The user is able to search for there city and weather information will be displayed. Technologies used: JavaScript, HTML, CSS, Bootstrap, Api's. Visit: https://openweathermap.org/ for an API key.The user is able to search for there city and weather information will be displayed. Technologies used: JavaScript, HTML, CSS, Bootstrap, Api's. Visit: https://openweathermap.org/ for an API key.",
    image: "./light1.jpg",
  },
  {
    title: "Error 404",
    subtitle: "Responsive 404",
    description:
      "The user is able to search for there city and weather information will be displayed. Technologies used: JavaScript, HTML, CSS, Bootstrap, Api's. Visit: https://openweathermap.org/ for an API key.The user is able to search for there city and weather information will be displayed. Technologies used: JavaScript, HTML, CSS, Bootstrap, Api's. Visit: https://openweathermap.org/ for an API key.",
    image: "./light2.jpg",
  },
  {
    title: "Error 404",
    subtitle: "Responsive 404",
    description:
      "The user is able to search for there city and weather information will be displayed. Technologies used: JavaScript, HTML, CSS, Bootstrap, Api's. Visit: https://openweathermap.org/ for an API key.The user is able to search for there city and weather information will be displayed. Technologies used: JavaScript, HTML, CSS, Bootstrap, Api's. Visit: https://openweathermap.org/ for an API key.",
    image: "./outdoorp02.PNG",
  },
  {
    title: "Error 404",
    subtitle: "Responsive 404",
    description:
      "The user is able to search for there city and weather information will be displayed. Technologies used: JavaScript, HTML, CSS, Bootstrap, Api's. Visit: https://openweathermap.org/ for an API key.The user is able to search for there city and weather information will be displayed. Technologies used: JavaScript, HTML, CSS, Bootstrap, Api's. Visit: https://openweathermap.org/ for an API key.",
    image: "./panel.jpg",
  },
  {
    title: "Error 404",
    subtitle: "Responsive 404",
    description:
      "The user is able to search for there city and weather information will be displayed. Technologies used: JavaScript, HTML, CSS, Bootstrap, Api's. Visit: https://openweathermap.org/ for an API key.The user is able to search for there city and weather information will be displayed. Technologies used: JavaScript, HTML, CSS, Bootstrap, Api's. Visit: https://openweathermap.org/ for an API key.",
    image: "./panel4.jpg",
  },
  {
    title: "Error 404",
    subtitle: "Responsive 404",
    description:
      "The user is able to search for there city and weather information will be displayed. Technologies used: JavaScript, HTML, CSS, Bootstrap, Api's. Visit: https://openweathermap.org/ for an API key.The user is able to search for there city and weather information will be displayed. Technologies used: JavaScript, HTML, CSS, Bootstrap, Api's. Visit: https://openweathermap.org/ for an API key.",
    image: "./panel0.jpg",
  },
  {
    title: "Error 404",
    subtitle: "Responsive 404",
    description:
      "The user is able to search for there city and weather information will be displayed. Technologies used: JavaScript, HTML, CSS, Bootstrap, Api's. Visit: https://openweathermap.org/ for an API key.The user is able to search for there city and weather information will be displayed. Technologies used: JavaScript, HTML, CSS, Bootstrap, Api's. Visit: https://openweathermap.org/ for an API key.",
    image: "./outdoorp.jpg",
  },

{
    title: "PrimeTime",
    subtitle: "Yelp API / Google Maps API",
    description:
      "The user is able to search for there city and weather information will be displayed. Technologies used: JavaScript, HTML, CSS, Bootstrap, Api's. Visit: https://openweathermap.org/ for an API key.The user is able to search for there city and weather information will be displayed. Technologies used: JavaScript, HTML, CSS, Bootstrap, Api's. Visit: https://openweathermap.org/ for an API key.",
    image: "./trench01.PNG",
  },

];

export const testimonials = [
  {
    quote:
      "'' Highly recommend Rey and Sons Electric! They were incredibly professional from start to finish. It’s rare to find a team with such a great work ethic these days. I’ll definitely be using them again for future projects. ''",
    image: "./chris.png",
    name: "- Israel",
    company: "",
  },
  {
    quote:
      "'' Can't say enough good things about this company. In terms of quality, they are top-notch and the pricing is always fair and honest. Highly recommend for any electrical work you may need! Positive, Responsiveness, Punctuality, Quality, Professionalism, Value ''",
    image: "./joel.png",
    name: "- Joel",
    company: "",
  },
];

export const skills = [
  "Residential Electrical Services",
  "Commercial Electrical Services",
  "Main Panel Upgrades",
  "Residential EV Chargers",
  "Electrical Wiring",
  "Electrical Outlets",
  "Smart Light Switch Upgrades",
  "Ceiling Fan Installations",
  "Home Outdoor Lighting ",
  "Smart Home Door Bells",
];



// WEBPACK FOOTER //
// ./src/data.js